module.exports = __webpack_public_path__ + "static/img/5.649fd591.png";